import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Box, Group, Text, Loader, Radio, Textarea } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils } from "../../utils/globalVariables";
import { safeValue } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import LabelWithAsterisk from "../../components/general/LabelWithAsterisk";

import PaperWrapper from "../../components/utilities/PaperWrapper";

const ComponentAlamat = ({
    stateData,
    stateKey,
    utilsRef,
    fnCloseDrawer,
    fnSubmitAlamatSelector,
    fnSubmitAlamatLain
}) => {

    const mountedRef = React.useRef(true);

    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorAlamatSelector: 'componentAlamat-2',
        errorAlamatLain: 'componentAlamat-3',
    })

    const canEditBarang = React.useRef([
        utils.penjemputanSteps.nota.value,
        utils.penjemputanSteps.segera_menjemput.value,
    ])

    const [data, setData] = React.useState({
        alamat: {
            masterId: '',
            selectorLoadingSubmit: false,
            alamatLain: '',
            stateKey: '',
            alamatLainModal: false,
            alamatLainSubmitLoading: false,
        },

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitAlamatSelector = (val, masterId, stateKey) => {
        setData(d => ({ ...d, alamat: { ...d.alamat, selectorLoadingSubmit: true } }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('master_id', masterId);
        formDT.append('current_step', utilsRef.currentStep);
        formDT.append('is_cancel', utilsRef.isCancel);

        formDT.append('alamat_selector_selected', val);

        axios({
            method: 'post',
            url: BE_API_THREE + '/update_delivery_penjemputan__alamat_selector',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, alamat: { ...d.alamat, selectorLoadingSubmit: false } }));

            if (response.data.flag_status === 'isset') {
                fnSubmitAlamatSelector(stateKey, 'alamat_selector', val);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorAlamatSelector,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                fnCloseDrawer();

                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, alamat: { ...d.alamat, selectorLoadingSubmit: false } }));

            notifications.show({
                id: notificationId.current.errorAlamatSelector,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const submitAlamatLain = () => {
        setData(d => ({ ...d, alamat: { ...d.alamat, alamatLainSubmitLoading: true } }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('master_id', data.alamat.masterId);
        formDT.append('current_step', utilsRef.currentStep);
        formDT.append('is_cancel', utilsRef.isCancel);

        formDT.append('alamat_lain', data.alamat.alamatLain);

        axios({
            method: 'post',
            url: BE_API_THREE + '/update_delivery_penjemputan__alamat_lain',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, alamat: { ...d.alamat, alamatLainSubmitLoading: false, alamatLainModal: false } }));

            if (response.data.flag_status === 'isset') {
                fnSubmitAlamatLain(data.alamat.stateKey, 'alamat_lain', data.alamat.alamatLain);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorAlamatLain,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                fnCloseDrawer();

                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, alamat: { ...d.alamat, alamatLainSubmitLoading: false, alamatLainModal: false } }));

            notifications.show({
                id: notificationId.current.errorAlamatLain,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={
                    <Group spacing={6}>
                        <LabelWithAsterisk stateLabel='Alamat Penjemputan' />
                        {data.alamat.selectorLoadingSubmit && <Loader size="xs" />}
                    </Group>
                }
                stateWithAsterisk={false}
                stateError=''
                stateDescription=''
                stateMB="2rem"
            >
                <PaperWrapper>
                    <Radio
                        label={
                            <Box onClick={(e) => { e.preventDefault() }}>
                                <Text
                                    fw={500}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}
                                >
                                    Alamat (Default)
                                </Text>

                                <Text mb='xs'>
                                    {safeValue(stateData.customer_address, '[Alamat]')}
                                </Text>
                            </Box>
                        }
                        checked={stateData.alamat_selector === utils.alamatSelector.default.value}
                        readOnly={!canEditBarang.current.includes(utilsRef.currentStep)}
                        onChange={!canEditBarang.current.includes(utilsRef.currentStep) ?
                            () => { }
                            :
                            () => {
                                submitAlamatSelector(utils.alamatSelector.default.value, stateData.delivery_jemput_id, stateKey);
                            }}

                        mb='xs'

                        styles={(tema) => ({
                            labelWrapper: {
                                width: '100%'
                            }
                        })}
                    />

                    <Radio
                        label={
                            <Box onClick={(e) => e.preventDefault()}>
                                <Text
                                    fw={500}
                                    mb='xs'

                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}
                                >
                                    Alamat Lain
                                </Text>

                                <Textarea
                                    value={safeValue(stateData.alamat_lain, '')}

                                    onClick={!canEditBarang.current.includes(utilsRef.currentStep) ?
                                        () => { }
                                        :
                                        () => setData(d => ({
                                            ...d,
                                            alamat: {
                                                ...d.alamat,
                                                masterId: stateData.delivery_jemput_id,
                                                alamatLain: stateData.alamat_lain,
                                                stateKey: stateKey,
                                                alamatLainModal: true
                                            }
                                        }))}

                                    disabled={stateData.alamat_selector === utils.alamatSelector.default.value}
                                    readOnly={true}

                                    styles={(tema) => ({
                                        input: {
                                            backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7]
                                        }
                                    })}

                                    autosize
                                    minRows={2}
                                    maxRows={5}
                                    label=''
                                    placeholder='Alamat Lain'
                                />
                            </Box>
                        }
                        checked={stateData.alamat_selector === utils.alamatSelector.other.value}

                        readOnly={!canEditBarang.current.includes(utilsRef.currentStep)}
                        onChange={!canEditBarang.current.includes(utilsRef.currentStep) ?
                            () => { }
                            :
                            () => {
                                submitAlamatSelector(utils.alamatSelector.other.value, stateData.delivery_jemput_id, stateKey);
                            }}

                        styles={(tema) => ({
                            labelWrapper: {
                                width: '100%'
                            }
                        })}
                    />
                </PaperWrapper>
            </InputWrapperCustom>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.alamat.alamatLainModal}
                fnHide={() => setData(d => ({ ...d, alamat: { ...d.alamat, alamatLainModal: false } }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Alamat Penjemputan Lain').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.alamat.alamatLainSubmitLoading}
                fnButtonAction={submitAlamatLain}
            >
                <Textarea
                    value={safeValue(data.alamat.alamatLain, '')}
                    minRows={3}
                    maxRows={4}
                    onChange={(e) => setData(d => ({ ...d, alamat: { ...d.alamat, alamatLain: e.target.value } }))}

                    label=''
                    placeholder='Alamat'
                    error=''
                    description=''
                    withAsterisk={false}
                />
            </ModalTakeAction>

        </React.Fragment>
    )
}

export default ComponentAlamat;